<template>
  <a :href="src" download target="_blank" :class="{iconless: !getThemedVar('fileDownloadIconEnabled', true) }">
    <v-icon v-if="getThemedVar('fileDownloadIconEnabled', true)">attach_file</v-icon>
    <p class="filename">{{ $t(filename) }}</p>
    <p v-if="size !== null" class="fileinfo">
      {{ format }} ({{
        parseFloat(size / 1e6)
          .toFixed(2)
      }} MB)
    </p>
  </a>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: ['filename', 'format', 'size', 'src'],
  computed: {
    ...mapGetters('service', ['getThemedVar']),
  },
};
</script>

<style lang="scss" scoped>
a {
  display: inline-block;
  width: auto;
  position: relative;
  vertical-align: middle;
  color: var(--file-download-color, rgba(0, 0, 0, 0.87));
  text-decoration: none;

  &:not(.iconless) {
    padding-left: 27px;
  }

  p {
    margin: 0;
  }

  .filename {
    text-decoration: none;
    width: 100%;
  }

  .fileinfo {
    font-size: 0.75em;
  }

  i {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
